import React, { useState } from "react";
import { Chatbot, createChatBotMessage } from "react-chatbot-kit";
import "react-chatbot-kit/build/main.css";
import "../Styles/ChatBot.css";
import botIcon from "../Images/Mati-Haat.webp";

const config = (setShowChat) => ({
  botName: "MatiHaat SupportBot",
  initialMessages: [createChatBotMessage("Hey there! Can I know your name?")],
  customStyles: {
    botMessageBox: { backgroundColor: "#198754" },
    chatButton: { backgroundColor: "#198754" },
  },
  customComponents: {
    botAvatar: () => <img src={botIcon} alt="Bot" className="bot-avatar" />,
    header: () => (
      <div className="chatbot-header">
        <span>MatiHaat Support</span>
        <button className="close-chat" onClick={() => setShowChat(false)}>×</button>
      </div>
    ),
  },
});

class MessageParser {
  constructor(actionProvider) {
    this.actionProvider = actionProvider;
  }

  parse(message) {
    this.actionProvider.handleUserMessage(message);
  }
}

class ActionProvider {
  constructor(createChatBotMessage, setStateFunc) {
    this.createChatBotMessage = createChatBotMessage;
    this.setState = setStateFunc;
  }

  handleUserMessage = (message) => {
    this.setState((prev) => {
      const step = prev?.step || 0;
      const userData = { ...prev?.userData } || {};
      const messages = prev?.messages ? [...prev.messages] : [];

      if (step === 0) {
        userData.name = message;
        return this.updateChatbotState("Got it! What's your order number?", step + 1, userData, messages);
      } else if (step === 1) {
        userData.orderNumber = message;
        return this.updateChatbotState("Thanks! What issue are you facing?", step + 1, userData, messages);
      } else if (step === 2) {
        userData.query = message;
        return this.updateChatbotState("Alright! Could you share your phone number?", step + 1, userData, messages);
      } else if (step === 3) {
        userData.phone = message;
        this.sendToWhatsApp(userData);
        return this.updateChatbotState("Your request has been sent to WhatsApp!", 0, {}, messages);
      }

      return prev;
    });
  };

  updateChatbotState = (question, step, userData, messages) => {
    const message = this.createChatBotMessage(question);
    return {
      messages: [...messages, message], 
      step,
      userData,
    };
  };

  sendToWhatsApp = (userData) => {
    const whatsappURL = `https://api.whatsapp.com/send?phone=919654870373&text=${encodeURIComponent(
      `Name: ${userData.name}\nOrder Number: ${userData.orderNumber}\nQuery: ${userData.query}\nPhone: ${userData.phone}`
    )}`;
    window.open(whatsappURL, "_blank");
  };
}

export default function WhatsAppChatBot() {
  const [showChat, setShowChat] = useState(false);

  return (
    <div className="chatbot-container">
      {!showChat && (
        <div className="chatbot-icon-container" onClick={() => setShowChat(true)}>
          <span className="chatbot-text">Need help? Let's chat!</span>
          <img src={botIcon} alt="Chatbot" className="chatbot-icon" />
        </div>
      )}
      {showChat && (
        <div className="chatbot-window">
          <div className="chatbot-body">
            <Chatbot config={config(setShowChat)} messageParser={MessageParser} actionProvider={ActionProvider} />
          </div>
        </div>
      )}
    </div>
  );
}
